import React from 'react';
import { pure } from '@dbk/ui-react-utils';

import ChartHeader from '../../positions/chart-header';

function FxForwardsChartHeader(props) {
  return (
    <ChartHeader
      valueLabel="FX Forward Rate"
      dayChangeLabel="Change"
      {...props}
    />
  );
}

FxForwardsChartHeader.propTypes = ChartHeader.propTypes;

export default pure(FxForwardsChartHeader);
